"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var constant_manager_1 = __importDefault(require("constant-manager"));
exports["default"] = constant_manager_1["default"]({
    SET_MESSAGES: '',
    SEND_MESSAGE: '',
    SEND_MESSAGE_REQUEST: '',
    // SET_USER_PRESENCE: '',
    MESSAGE_RECEIVED: '',
    ADD_ROOM: '',
    DELETE_ROOM: '',
    SET_UNREAD: '',
    SET_MYSELF: '',
    ADD_USER: '',
    ROOM_MEMBERS_SET: '',
    ADD_USER_TO_IGNORED: '',
    MESSAGE_QUEUE_ADD: '',
    MESSAGE_QUEUE_REMOVE: '',
    MESSAGE_QUEUE_ERROR: '',
    CREATE_MOCK_DIRECT_ROOM: '',
    SET_CHAT_UPDATE_TIME: '',
    SET_ROOM_DIRECT_OFFSET: '',
    SET_ROOM_GROUPS_OFFSET: '',
    RUN_CLEANER: '',
    // 3rd party
    SET_ROOM_MUTED: ''
}, { prefix: 'RC_CHAT__' });
